import { render, staticRenderFns } from "./ClinicReschedules.vue?vue&type=template&id=574590f8"
import script from "./ClinicReschedules.vue?vue&type=script&lang=js"
export * from "./ClinicReschedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports